var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_15238","data-name":"Group 15238","transform":"translate(-772.514 -1156.827) rotate(45)"},[React.createElement("line",{"id":"Line_38","data-name":"Line 38","y2":"18","transform":"translate(1374.5 262.5)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_39","data-name":"Line 39","x1":"18","transform":"translate(1365.5 272)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"1","key":1})]));
}

IconClose.defaultProps = {"width":"14.496","height":"14.496","viewBox":"0 0 14.496 14.496"};

module.exports = IconClose;

IconClose.default = IconClose;
